import admin from "./admin/index"
export default admin
